export default "__VITE_ASSET__BOi9vh23__"